import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import keys from "./keys";
import { useApi } from "../client";

interface CreateUserValues {
  lastname: string;
  firstname: string;
  email: string;
  client_id: string;
}

export const useCreateUser = (clientId: string) => {
  const api = useApi();
  const queryKey = keys.all();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CreateUserValues) => {
      const requestOptions = {
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      };
      const response = await api.post(
        `clients/${clientId}/user`,
        requestOptions
      );

      return response.json();
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: queryKey });
      toast.success("Utilisateur créé");
    },
    onError: () => {
      toast.error("Nous n'avons pas pu créer l'utilisateur");
    },
  });
};

export const useDeleteUser = (clientId: string) => {
  const api = useApi();
  const queryClient = useQueryClient();
  const queryKey = keys.all();

  return useMutation({
    mutationFn: async (userId: string) => {
      const requestOptions = {
        headers: { "Content-Type": "application/json" },
      };
      const response = await api.delete(
        `clients/${clientId}/user/${userId}`,
        requestOptions
      );

      return response.json();
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: queryKey });
      toast.info("Utilisateur supprimé");
    },
    onError: () => {
      toast.error("Nous n'avons pas pu supprimer l'utilisateur");
    },
  });
};
